export default __webpack_public_path__ + "static/media/deletewhite.bec53d33.svg";